/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/socials/Comp Table.jpeg";

const imageAltText = "desktop with books, laptop, and coffee cup";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "My Diary Excerpt.",
    description:
      "My memory during a memorable visit to a famous software house located in Karachi.",
    url: "https://www.youtube.com/watch?v=rUMX2wrhOug",
  },
  {
    title: "Web Designing For Beginners",
    description:
      "A web page design html program for Weather Monitoring System.",
    url: "https://github.com/MahEUrooj/Weather-Monitoring-System",
  },
  {
    title: "My Internet Of Things Final Project at Sir Syed University of Engineering and Technology through collaboration of NAVTCC- initiated by Kamyab Jawan Pakistan",
    description:
      "My work during six months course of Internet of Things.",
    url: "https://www.youtube.com/watch?v=73pAGt2G_Os&t=23s",
  },
  {
    title: "Teaching is a noble profession.",
    description:
      "A short clip of working with students of Akhter Government Girls Secondary School (AGGSS)",
    url: "https://www.youtube.com/shorts/tG_lQZ-_530",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center" }}>Portfolio</h2>
      <div style={{ display: "flex", flexDirection: "row", paddingTop: "3rem" }}>
        <div style={{ maxWidth: "40%", alignSelf: "center" }}>
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover" }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
